import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { ClassAttributeType } from '../../../../../../api/types/settings/class-attributes/class-attribute-types';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const addClassAttributes = async (
  listName: string,
  attributeName: string,
  attributeType: ClassAttributeType | null,
  onClose: () => any,
) => {
  try {
    if (listName.length < 3 || listName.length > 60) {
      toast.warn('על שם הרשימה להיות בת 3 עד 60 תווים');
      toast.warn(listName);
      return;
    }
    if (attributeType === null || attributeName.length < 3) {
      toast.warn('יש למלא את הפרטים לפני השמירה');
      return;
    }

    const asd = await appApi.addClassAttributes(
      listName,
      attributeName,
      attributeType,
    );
    globalSettingsStores.fetchSetting();
    onClose();
  } catch (e) {
    console.error(
      `addClassAttributes si failed with the attributeName: ${attributeName}, attributeType: ${attributeType}`,
    );
    toast.error('הפועולה נכשלה, יש לנסות שוב בעוד מספר רגעים');
  }
};
